export const WIDGET_INTEGRATION_GOOGLE_FONTS = [
  'Roboto',
  'Open Sans',
  'Lato',
  'Montserrat',
  'Poppins',
  'Inter',
  'Raleway',
  'Ubuntu',
  'Nunito',
  'Source Sans Pro',
  'Oswald',
  'Work Sans',
  'DM Sans',
  'Noto Sans',
  'Fira Sans',
  'PT Sans',
  'Quicksand',
  'Dosis',
  'Barlow',
  'Manrope',
  'Outfit',
  'Plus Jakarta Sans',
  'Figtree',
  'Playfair Display',
  'Merriweather',
  'Lora',
  'Crimson Text',
  'PT Serif',
  'Libre Baskerville',
  'Bitter',
  'Cormorant Garamond',
  'EB Garamond',
  'Pacifico',
  'Dancing Script',
  'Great Vibes',
  'Satisfy',
  'Kalam',
  'Caveat',
  'Amatic SC',
  'Bebas Neue',
  'Righteous',
  'Fredoka One',
  'Lobster',
  'Shadows Into Light',
];

export function ensureWidgetIntegrationGoogleFont(fontFamily) {
  if (!fontFamily || !WIDGET_INTEGRATION_GOOGLE_FONTS.includes(fontFamily)) {
    return;
  }
  const fontName = fontFamily.replace(/\s+/g, '+');
  const linkId = `google-font-${fontName}`;
  if (!document.getElementById(linkId)) {
    const link = document.createElement('link');
    link.id = linkId;
    link.rel = 'stylesheet';
    link.href = `https://fonts.googleapis.com/css2?family=${fontName}:wght@300;400;500;600;700&display=swap`;
    document.head.appendChild(link);
  }
}
